import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { BlogModel } from '@models/blog.model';
import { environment } from '@environment';

@Injectable({
  providedIn: 'root'
})
export class BlogService {

  constructor(private http: HttpClient,
              private translate: TranslateService) { }

  getBlog(limit: number = 100): Observable<BlogModel> {
    const queryParams = {
      key: environment.blogKey,
      fields: 'id,published_at,title,primary_tag,url,feature_image,excerpt,slug, meta_description',
      formats: 'plaintext',
      include: 'tags,authors',
      limit: limit,
      filter: 'tags:' + (this.translate.currentLang === 'de' ? '[releases-de,de]' : '[releases-en,en]'),
      order: 'published_at desc'
    };
    return this.http.get<BlogModel>(environment.blogApiUrl + 'content/posts/', {params: queryParams});
  }

  getPost(slug: string): Observable<BlogModel> {
    const queryParams = {
      key: environment.blogKey,
      include: 'tags,authors',
    //  fields: 'id,published_at,title,primary_tag,url,feature_image,excerpt,slug',
    };
    return this.http.get<BlogModel>(environment.blogApiUrl + 'content/posts/slug/' + slug + '/', {params: queryParams});
  }

}
